import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Stethoscope, Loader2, Mail, ArrowLeft, ShieldCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setError(null); setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (e) { setError(formatApiError(e)); }
        finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-base flex items-center justify-center px-4 py-10">
            <div className="w-full max-w-md">
                <Link to="/" className="flex items-center gap-2 justify-center mb-8">
                    <span className="w-10 h-10 rounded-xl bg-brand text-white flex items-center justify-center">
                        <Stethoscope size={18} />
                    </span>
                    <span className="font-display text-brand text-lg font-semibold">Clínica Fernandes</span>
                </Link>
                <div className="card-earthy">
                    {!sent ? (
                        <>
                            <h1 className="font-display text-2xl font-medium text-brand mb-1">Recuperar senha</h1>
                            <p className="text-sm text-muted-clinical mb-6">Informe o e-mail cadastrado e enviaremos as instruções para redefinir sua senha.</p>
                            <form onSubmit={submit} className="space-y-4">
                                <div>
                                    <label className="label-clinical">E-mail</label>
                                    <input
                                        data-testid="forgot-email"
                                        type="email"
                                        autoComplete="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        className="input-clinical"
                                        placeholder="voce@email.com"
                                    />
                                </div>
                                {error && (
                                    <div data-testid="forgot-error" className="text-sm text-[var(--status-danger)] bg-[var(--status-danger-bg)] border-l-4 border-[var(--status-danger)] p-3 rounded">{error}</div>
                                )}
                                <button data-testid="forgot-submit" type="submit" disabled={loading || !email} className="btn-primary w-full">
                                    {loading ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />} Enviar instruções
                                </button>
                            </form>
                        </>
                    ) : (
                        <div data-testid="forgot-sent" className="text-center py-4">
                            <div className="w-14 h-14 mx-auto rounded-full bg-alt text-brand flex items-center justify-center mb-4">
                                <ShieldCheck size={28} />
                            </div>
                            <h2 className="font-display text-2xl text-brand mb-2">Verifique seu e-mail</h2>
                            <p className="text-sm text-muted-clinical mb-2">
                                Se o e-mail informado estiver cadastrado, você receberá um link seguro para redefinir sua senha em instantes.
                            </p>
                            <p className="text-xs text-muted-clinical bg-alt rounded p-3 mt-4">
                                Não recebeu? Verifique a pasta de spam ou peça ao administrador da clínica para gerar uma <strong>senha temporária</strong> (na área de gestão de usuários).
                            </p>
                        </div>
                    )}
                    <div className="mt-6 text-center text-sm text-muted-clinical">
                        <Link data-testid="forgot-back-login" to="/login" className="text-brand font-medium hover:underline inline-flex items-center gap-1">
                            <ArrowLeft size={14} /> Voltar ao login
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
